export function Footer() {
  return (
    <footer
      role="contentinfo"
      className="bg-surface-container-lowest w-full px-2 py-5"
    >
      <p className="text-tertiary text-center text-sm">
        Designed and created by @decisivestrike
      </p>
    </footer>
  );
}
